import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import API from "../services/api";

export default function StudentProfile() {

    const { id } = useParams();

    const navigate = useNavigate();

    const [student, setStudent] = useState(null);
    const [feeSummary, setFeeSummary] = useState(null);
    const [payments, setPayments] = useState([]);

    useEffect(() => {

        loadStudent();
        loadFeeSummary();
        loadPayments();

    }, []);


    const loadStudent = async () => {

        try {

            const res = await API.get(`/students/${id}`);

            setStudent(res.data);

        }

        catch (err) {

            console.log(err);

        }

    };

    const loadFeeSummary = async () => {

        try {

            const res = await API.get(
                `/student-fee/${id}/summary`
            );

            setFeeSummary(res.data);

        }

        catch (err) {

            console.log(err);

        }

    };

    const loadPayments = async () => {

        try {

            const res = await API.get(
                `/student-fee/${id}/payments`
            );

            setPayments(res.data);

        }

        catch (err) {

            console.log(err);

        }

    };

    if (!student) {

        return (

            <div className="p-8">

                <h1 className="text-3xl font-bold">
                    Student Profile
                </h1>

                <p className="mt-4 text-gray-500">
                    Loading student...
                </p>

            </div>

        );

    }

    return (

        <div className="p-8 bg-gray-100 min-h-screen">

            {/* Back Button */}

            <button

                onClick={() => navigate("/student-directory")}

                className="mb-6 bg-gray-700 hover:bg-gray-800 text-white px-4 py-2 rounded-lg"

            >

                ← Back to Student Directory

            </button>


            {/* Header */}

            <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">

                <div className="flex justify-between items-start">

                    <div>

                        <h1 className="text-4xl font-bold text-gray-800">

                            {student.name}

                        </h1>

                        <p className="text-gray-500 mt-2">

                            Admission No :
                            <span className="font-semibold">
                                {" "}
                                {student.admission_no}
                            </span>

                        </p>

                        <p className="text-gray-500">

                            Class {student.class} - {student.section}

                        </p>

                    </div>

                    <div className="flex gap-3">

                        <button

                            className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-lg"

                        >

                            Edit Student

                        </button>

                        <button

                            className="bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-lg"

                        >

                            Print Profile

                        </button>

                    </div>

                </div>

            </div>



            {/* Basic Details */}

            <div className="bg-white rounded-2xl shadow-lg p-6 mb-8">

                <h2 className="text-2xl font-bold mb-6">

                    📋 Basic Details

                </h2>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">

                    <div>

                        <p className="text-gray-500 text-sm">

                            Admission No

                        </p>

                        <p className="font-semibold">

                            {student.admission_no || "Not Available"}

                        </p>

                    </div>

                    <div>

                        <p className="text-gray-500 text-sm">

                            Roll Number

                        </p>

                        <p className="font-semibold">

                            {student.roll_no || "Not Available"}

                        </p>

                    </div>

                    <div>

                        <p className="text-gray-500 text-sm">

                            Class

                        </p>

                        <p className="font-semibold">

                            {student.class || "Not Available"}

                        </p>

                    </div>

                    <div>

                        <p className="text-gray-500 text-sm">

                            Section

                        </p>

                        <p className="font-semibold">

                            {student.section || "Not Available"}

                        </p>

                    </div>

                    <div>

                        <p className="text-gray-500 text-sm">

                            Gender

                        </p>

                        <p className="font-semibold">

                            {student.gender || "Not Available"}

                        </p>

                    </div>

                    <div>

                        <p className="text-gray-500 text-sm">

                            Date of Birth

                        </p>

                        <p className="font-semibold">

                            {student.dob || "Not Available"}

                        </p>

                    </div>

                    <div>

                        <p className="text-gray-500 text-sm">

                            Blood Group

                        </p>

                        <p className="font-semibold">

                            {student.blood_group || "Not Available"}

                        </p>

                    </div>

                    <div>

                        <p className="text-gray-500 text-sm">

                            Admission Date

                        </p>

                        <p className="font-semibold">

                            {student.admission_date || "Not Available"}

                        </p>

                    </div>

                </div>

            </div>



            {/* Parent Details */}

            <div className="bg-white rounded-2xl shadow-lg p-6 mb-8">

                <h2 className="text-2xl font-bold mb-6">

                    👨‍👩‍👧 Parent Details

                </h2>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

                    <div>

                        <p className="text-gray-500 text-sm">

                            Father Name

                        </p>

                        <p className="font-semibold">

                            {student.father_name || "Not Available"}

                        </p>

                    </div>

                    <div>

                        <p className="text-gray-500 text-sm">

                            Mother Name

                        </p>

                        <p className="font-semibold">

                            {student.mother_name || "Not Available"}

                        </p>

                    </div>

                    <div>

                        <p className="text-gray-500 text-sm">

                            Guardian Name

                        </p>

                        <p className="font-semibold">

                            {student.guardian_name || "Not Available"}

                        </p>

                    </div>

                    <div>

                        <p className="text-gray-500 text-sm">

                            Parent Mobile

                        </p>

                        <p className="font-semibold">

                            {student.parent_mobile || "Not Available"}

                        </p>

                    </div>

                    <div>

                        <p className="text-gray-500 text-sm">

                            Parent Email

                        </p>

                        <p className="font-semibold">

                            {student.parent_email || "Not Available"}

                        </p>

                    </div>

                    <div>

                        <p className="text-gray-500 text-sm">

                            Emergency Contact

                        </p>

                        <p className="font-semibold">

                            {student.emergency_contact || "Not Available"}

                        </p>

                    </div>

                </div>

            </div>

            {/* ====== PART 2 STARTS FROM HERE ====== */}

            {/* Address */}

            <div className="bg-white rounded-2xl shadow-lg p-6 mb-8">

                <h2 className="text-2xl font-bold mb-6">
                    🏠 Address
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                    <div>

                        <p className="text-gray-500 text-sm">
                            Address
                        </p>

                        <p className="font-semibold">
                            {student.address || "Not Available"}
                        </p>

                    </div>

                    <div>

                        <p className="text-gray-500 text-sm">
                            City
                        </p>

                        <p className="font-semibold">
                            {student.city || "Not Available"}
                        </p>

                    </div>

                    <div>

                        <p className="text-gray-500 text-sm">
                            State
                        </p>

                        <p className="font-semibold">
                            {student.state || "Not Available"}
                        </p>

                    </div>

                    <div>

                        <p className="text-gray-500 text-sm">
                            PIN Code
                        </p>

                        <p className="font-semibold">
                            {student.pincode || "Not Available"}
                        </p>

                    </div>

                </div>

            </div>


            {/* Fee Summary */}

            <div className="bg-white rounded-2xl shadow-lg p-6 mb-8">

                <div className="flex justify-between items-center mb-6">

                    <h2 className="text-2xl font-bold">
                        💰 Fee Summary
                    </h2>

                    <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg">

                        Manage Fees

                    </button>

                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-6">

                    <div className="bg-blue-50 rounded-xl p-5">

                        <p className="text-gray-500 text-sm">
                            Annual Fee
                        </p>

                        <p className="text-2xl font-bold mt-2">
                            ₹{Number(feeSummary?.total_fee || 0).toLocaleString()}
                        </p>

                    </div>

                    <div className="bg-green-50 rounded-xl p-5">

                        <p className="text-gray-500 text-sm">
                            Paid
                        </p>

                        <p className="text-2xl font-bold mt-2 text-green-600">
                            ₹{Number(feeSummary?.paid || 0).toLocaleString()}
                        </p>

                    </div>

                    <div className="bg-red-50 rounded-xl p-5">

                        <p className="text-gray-500 text-sm">
                            Balance
                        </p>

                        <p className="text-2xl font-bold mt-2 text-red-600">
                            ₹{Number(feeSummary?.balance || 0).toLocaleString()}
                        </p>

                    </div>

                    <div className="bg-yellow-50 rounded-xl p-5">

                        <p className="text-gray-500 text-sm">
                            Status
                        </p>

                        <p
                            className={`text-xl font-bold mt-2 ${feeSummary?.status === "Paid"
                                    ? "text-green-600"
                                    : feeSummary?.status === "Partial"
                                        ? "text-yellow-600"
                                        : "text-red-600"
                                }`}
                        >
                            {feeSummary?.status || "Pending"}
                        </p>

                    </div>

                </div>

            </div>


            {/* Payment History */}

            <div className="bg-white rounded-2xl shadow-lg p-6 mb-8">

                <div className="flex justify-between items-center mb-6">

                    <h2 className="text-2xl font-bold">

                        💳 Payment History

                    </h2>

                </div>

                <div className="overflow-x-auto">

                    <table className="w-full">

                        <thead>

                            <tr className="border-b">

                                <th className="text-left py-3">
                                    Date
                                </th>

                                <th className="text-left py-3">
                                    Term
                                </th>

                                <th className="text-left py-3">
                                    Amount
                                </th>

                                <th className="text-left py-3">
                                    Payment Mode
                                </th>

                                <th className="text-left py-3">
                                    Transaction
                                </th>

                                <th className="text-left py-3">
                                    Received By
                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            {payments.length === 0 ? (

                                <tr>

                                    <td
                                        colSpan="6"
                                        className="text-center py-8 text-gray-500"
                                    >

                                        No Payments Found

                                    </td>

                                </tr>

                            ) : (

                                payments.map((payment, index) => (

                                    <tr
                                        key={index}
                                        className="border-b hover:bg-gray-50"
                                    >

                                        <td className="py-3">
                                            {new Date(payment.payment_date).toLocaleDateString()}
                                        </td>

                                        <td className="py-3">
                                            {payment.term}
                                        </td>

                                        <td className="py-3 font-semibold">
                                            ₹{Number(payment.amount_paid).toLocaleString()}
                                        </td>

                                        <td className="py-3">
                                            {payment.payment_mode || "-"}
                                        </td>

                                        <td className="py-3">
                                            {payment.transaction_reference || "-"}
                                        </td>

                                        <td className="py-3">
                                            {payment.updated_by || "-"}
                                        </td>

                                    </tr>

                                ))

                            )}

                        </tbody>

                    </table>

                </div>

            </div>


            {/* Attendance */}

            <div className="bg-white rounded-2xl shadow-lg p-6 mb-8">

                <h2 className="text-2xl font-bold mb-6">

                    📅 Attendance Summary

                </h2>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

                    <div className="bg-green-50 rounded-xl p-5">

                        <p className="text-gray-500 text-sm">

                            Present Days

                        </p>

                        <p className="text-3xl font-bold mt-2 text-green-600">

                            0

                        </p>

                    </div>

                    <div className="bg-red-50 rounded-xl p-5">

                        <p className="text-gray-500 text-sm">

                            Absent Days

                        </p>

                        <p className="text-3xl font-bold mt-2 text-red-600">

                            0

                        </p>

                    </div>

                    <div className="bg-blue-50 rounded-xl p-5">

                        <p className="text-gray-500 text-sm">

                            Attendance %

                        </p>

                        <p className="text-3xl font-bold mt-2 text-blue-600">

                            0%

                        </p>

                    </div>

                </div>

            </div>

        </div>

    );

}